﻿import * as React from 'react';
import { useQuery, useQueryClient } from 'react-query';
import { ImageEditorFirmsModal, ImageEditorFirmsModalLabels } from './ImageEditorFirmsModal';
import { Translate } from '../../../shared/LanguageService';
import { handleError } from '../../../shared/ErrorCatching';
import ImageEditorFirmsApi from '../api/ImageEditorFirmsApi';
import { IImageEditorFirm } from '../Entities';

type EditImageEditorFirmModalProps = {
    showModal: boolean;
    onClose: () => void;
    editorFirm: IImageEditorFirm;
    onSave: (ImageEditorFirm: IImageEditorFirm) => void;
};

type ExternalProps = {
    showModal: boolean;
    onClose: () => void;
    editFirmId: number;
    onSave: (ImageEditorFirm: IImageEditorFirm) => void;
};

const EditImageEditorFirmsModalTranslationLayer = (props: EditImageEditorFirmModalProps) => {
    let labels: ImageEditorFirmsModalLabels = {
        textfieldLegend: Translate('image-editor-firms/modal/textfield-legend'),
        dialogTitle: Translate('image-editor-firms/modal/dialog-title-update'),
        selectLegend: Translate('image-editor-firms/modal/select-legend'),
        cancelButton: Translate('image-editor-firms/modal/cancel-button'),
        saveButton: Translate('image-editor-firms/modal/save-button'),
        defaultCheckboxLabel: Translate('image-editor-firms/modal/default-checkbox-label'),
        expressCheckboxLabel: Translate('image-editor-firms/modal/express-checkbox-label'),
        deselectionIsNotAllowed: Translate('image-editor-firms/modal/deselection-is-not-allowed')
    };

    return (
        <ImageEditorFirmsModal
            editorFirm={props.editorFirm}
            onSave={props.onSave}
            onClose={props.onClose}
            showModal={props.showModal}
            labels={labels}
        />
    );
};

const EditImageEditorFirmsModalDataLayer = (props: ExternalProps) => {
    let imageEditorFirm = useQuery(['getImageEditorFirms', props.editFirmId], () =>
        ImageEditorFirmsApi.getImageEditorFirm(props.editFirmId)
    );

    let queryClient = useQueryClient();

    if (imageEditorFirm.isError) {
        handleError(imageEditorFirm.isError);
    }

    if (imageEditorFirm.isLoading) {
        /**
         * This solution looks better visually than to loading skeleton delegation to this level.
         *
         * Since this is used by our internal users network speed _should_ not cause this to look
         * too horrible.
         */
        return null;
    }
    
    function handleOnSave(imageEditorFirm: IImageEditorFirm) {
        queryClient.invalidateQueries(['getImageEditorFirms', props.editFirmId]);
        props.onSave(imageEditorFirm);
    }

    let editorFirm = imageEditorFirm.data ? imageEditorFirm.data : null;

    return (
        <EditImageEditorFirmsModalTranslationLayer
            showModal={props.showModal}
            editorFirm={editorFirm}
            onSave={handleOnSave}
            onClose={props.onClose}
        />
    );
};

export default EditImageEditorFirmsModalDataLayer;
